export * from './global-position/global-position.page';
